import React, { useState, useEffect } from 'react';
import "./Pagination.css"
function Pagination({ pages = 10, setCurrentPage, currentPage }) {

  const numberOfPages = [];
  for (let i = 1; i <= pages; i++) {
    numberOfPages.push(i);
  }

  //const [currentPage, setCurrentPage] = useState(1);
  const [arrOfCurrButtons, setArrOfCurrButtons] = useState([]);

  useEffect(() => {
    const calculatePaginationButtons = () => {
      let tempNumberOfPages = [];
      if (numberOfPages.length <= 7) {
        tempNumberOfPages = numberOfPages;
      } else if (currentPage <= 4) {
        tempNumberOfPages = [...numberOfPages.slice(0, 5), '...', numberOfPages.length];
      } else if (currentPage >= pages - 3) {
        tempNumberOfPages = [1, '...', ...numberOfPages.slice(pages - 5)];
      } else {
        tempNumberOfPages = [1, '...', currentPage - 1, currentPage, currentPage + 1, '...', numberOfPages.length];
      }
      setArrOfCurrButtons(tempNumberOfPages);
      setCurrentPage(currentPage);
    };

    calculatePaginationButtons();
 // eslint-disable-next-line
  }, [currentPage, setCurrentPage, pages, numberOfPages.length]);

  return (
    <div className="pagination-container" >
      
      <button
        
        className={`${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => setCurrentPage(1)}
      >
        First
      </button>
      <button
        
        className={`pagination-button ${currentPage === 1 ? 'disabled' : ''}`}
        onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
      >
        Prev
      </button>

      {arrOfCurrButtons.map((item, index) => (
        <button
          
          key={index}
          className={`pagination-button ${currentPage === item ? 'active' : ''}`}
          onClick={() => setCurrentPage(item)}
        >
          {item}
        </button>
      ))}

      <button
        
        className={`pagination-button ${currentPage === pages ? 'disabled' : ''}`}
        onClick={() => setCurrentPage(prev => Math.min(prev + 1, pages))}
      >
        Next
      </button>
      <button
        
        className={`${currentPage === numberOfPages.length ? 'disabled' : ''}`}
        onClick={() => setCurrentPage(numberOfPages.length)}
      >
        Last
      </button>
    </div>
  );
}

export default Pagination;
